import Resolver, { http } from "@/api/resolver";
import _ from "lodash";
import Vue from "vue";

export const vueError = (error: Error, vm: Vue, info: string) => {
  // eslint-disable-next-line no-console
  console.error(error, vm, info);

  const stack = getFirstLineOfStack(error.stack);
  const message = `Vue error: ${vm.$options.name} @ ${info}: ${stack}`;

  sendError(message);
};

export const unhandledPromiseRejectionError = (event: any) => {
  // eslint-disable-next-line no-console
  console.error(event);

  const stack = getFirstLineOfStack(_.get(event, "reason.stack"));
  const message = `Global Unhandled Promise Rejection Error: ${stack}`;

  sendError(message);
};

export const globalError = (event: ErrorEvent) => {
  // eslint-disable-next-line no-console
  console.error(event);

  const fileName = event.filename as string;
  let parsedFileName = "";
  if (fileName) {
    const parts = fileName.split("?").filter(line => line.startsWith("!"));
    parsedFileName = parts[parts.length - 1];
  }
  const lineNumber = event.lineno;
  const eventMessage = event.message;
  const message = `Global error: ${eventMessage} in (${parsedFileName}) line number: ${lineNumber}`;

  sendError(message);
};

export const sendError = async (message: string) => {
  // Hash is everything after the # which is our entire url + query string
  const hash = location.hash;
  message = `${message};hash=${hash}`;
  const data: Record<string, any> = {
    data: message,
    type: "text"
  };

  const formData = new FormData();
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });

  try {
    const response = await http({
      method: "post",
      url: Resolver.logRequest,
      data: formData
    });
    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to log error to server", error);
  }
};

const getFirstLineOfStack = (rawStack: string | undefined) => {
  let stack = "NO STACK";
  if (rawStack && rawStack.split(/\n/g).length) {
    stack = rawStack.split(/\n/g)[0];
  }
  return stack;
};
